import React from "react";
import Header from "../components/common/Header";

const SettingPage = () => {
  return (
    <div>
      <Header></Header>
      <div>
        {/* Left */}
        <div className="max-w-[40%] w-full"></div>
      </div>
    </div>
  );
};

export default SettingPage;
